import Flex from "antd/es/flex";
import "./styles/queue.less"
import dayjs from "dayjs";
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";
import {Image} from "antd";

export default function QueueHeader() {

    const {xl} = useBreakpoint();

    const getNow = () => {
        return dayjs().format("DD.MM.YYYY HH:mm")
    }

    return (
        <Flex className={xl ? "queue-header" : "queue-header-mobile"} justify={"space-between"} align={"center"}>
            <Flex style={{width: '100%'}}>
                <Flex style={xl ? {width: '548px', height: '120px'} : {width: '80%'}} justify={"center"}
                      align={"center"}>
                    <Image src={"/content/queue_logo.png"}/>
                </Flex>
            </Flex>
            <Flex style={{width: '100%'}} justify={"flex-end"}>
                <div>{`${getNow()}`}</div>
            </Flex>
        </Flex>
    )
}